export default __webpack_public_path__ + "static/media/9881.3dcc291c.png";